import { toObjectMap } from "../utilities/dictionary";

const statusTypes = ["FULFILLED", "PENDING", "REJECTED", "CANCELLED"] as const;
type StatusType = (typeof statusTypes)[number];
const statusTypeMap = toObjectMap<StatusType>([...statusTypes]);

export { statusTypeMap, statusTypes };
export type { StatusType };
